import * as React from 'react';
import { useAuth } from './useAuth';

export function withAuth<TProps>(
  WrappedComponent: React.ComponentType<
    Bluebeam.Auth.Models.WithAuthProps<TProps>
  >
): React.FC<TProps> {
  const WithAuthContainerWrapper: React.FC<TProps> = (props) => {
    const credentials = useAuth();

    // @ts-ignore
    return <WrappedComponent {...props} useAuth={credentials} />;
  };

  WithAuthContainerWrapper.displayName = `withAuth(${
    WrappedComponent.displayName || WrappedComponent.name
  })`;

  return WithAuthContainerWrapper;
}
